var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateAudit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Create_Audit"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Create_Audit",
    "data-name": "Create Audit",
    clipPath: "url(#clip-Create_Audit)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_255",
    "data-name": "Ellipse 255",
    transform: "translate(1 1)",
    fill: "#0069bf",
    stroke: "#0081ea",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15694",
    "data-name": "Group 15694",
    transform: "translate(13800.123 17372.971)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    transform: "translate(-13793.123 -17365.971)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32720",
    "data-name": "Path 32720",
    d: "M7.66,0a.434.434,0,0,1,.315.489c-.007.093,0,.189,0,.3h.485A1.578,1.578,0,0,1,10.053,2.27c0,.047,0,.091,0,.138v6.1a.43.43,0,0,1-.128.347.368.368,0,0,1-.4.079A.377.377,0,0,1,9.273,8.6a1.11,1.11,0,0,1,0-.128V2.4a.768.768,0,0,0-.6-.8,4.556,4.556,0,0,0-.694-.039v.369a.394.394,0,1,1-.785,0V1.582H5.4v.354a.395.395,0,1,1-.787,0V1.579H2.846c0,.133,0,.266,0,.4a.39.39,0,0,1-.6.322.383.383,0,0,1-.184-.337c0-.123,0-.248,0-.386a2.165,2.165,0,0,0-.8.064.767.767,0,0,0-.48.755c0,.5,0,1.009,0,1.513V8.435a.778.778,0,0,0,.583.807.959.959,0,0,0,.251.03q3.409,0,6.816,0a.789.789,0,0,0,.834-.782.393.393,0,1,1,.785.037,1.576,1.576,0,0,1-1.51,1.528l-.069,0q-3.446,0-6.892,0A1.563,1.563,0,0,1,.086,8.99C.049,8.885.03,8.772,0,8.661V2.179a.351.351,0,0,0,.02-.054A1.547,1.547,0,0,1,.753,1.018,1.629,1.629,0,0,1,1.707.785c.116,0,.234,0,.354,0,0-.108,0-.2,0-.3A.434.434,0,0,1,2.376,0h.157a.434.434,0,0,1,.315.489c-.007.1,0,.194,0,.29H4.617c0-.1,0-.2,0-.29A.434.434,0,0,1,4.932,0h.157A.434.434,0,0,1,5.4.489c-.007.1,0,.194,0,.29H7.192c0-.1,0-.2,0-.29A.434.434,0,0,1,7.507,0c.047,0,.1,0,.153,0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32721",
    "data-name": "Path 32721",
    d: "M84.29,152.584a.392.392,0,1,1,.394-.394A.4.4,0,0,1,84.29,152.584Z",
    transform: "translate(-81.835 -148.065)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32722",
    "data-name": "Path 32722",
    d: "M153.694,151.8a.392.392,0,1,1-.007.785.392.392,0,0,1,.007-.785Z",
    transform: "translate(-149.529 -148.066)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32723",
    "data-name": "Path 32723",
    d: "M223.585,152.188a.392.392,0,1,1-.4-.389A.393.393,0,0,1,223.585,152.188Z",
    transform: "translate(-217.32 -148.065)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32724",
    "data-name": "Path 32724",
    d: "M293.078,152.191a.391.391,0,1,1-.394-.391A.393.393,0,0,1,293.078,152.191Z",
    transform: "translate(-285.106 -148.066)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32725",
    "data-name": "Path 32725",
    d: "M223.585,221.588a.392.392,0,1,1-.4-.389A.393.393,0,0,1,223.585,221.588Z",
    transform: "translate(-217.32 -215.758)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32726",
    "data-name": "Path 32726",
    d: "M293.078,221.591a.391.391,0,1,1-.394-.391A.393.393,0,0,1,293.078,221.591Z",
    transform: "translate(-285.106 -215.759)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32727",
    "data-name": "Path 32727",
    d: "M223.585,291.088a.392.392,0,1,1-.4-.389A.393.393,0,0,1,223.585,291.088Z",
    transform: "translate(-217.32 -283.548)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32728",
    "data-name": "Path 32728",
    d: "M293.078,291.091a.391.391,0,1,1-.394-.391A.393.393,0,0,1,293.078,291.091Z",
    transform: "translate(-285.106 -283.549)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32729",
    "data-name": "Path 32729",
    d: "M84.584,221.591a.392.392,0,1,1-.4-.391A.395.395,0,0,1,84.584,221.591Z",
    transform: "translate(-81.738 -215.759)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32730",
    "data-name": "Path 32730",
    d: "M154.084,221.694a.392.392,0,1,1-.785-.007.392.392,0,0,1,.785.007Z",
    transform: "translate(-149.528 -215.857)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32731",
    "data-name": "Path 32731",
    d: "M84.584,291.091a.392.392,0,1,1-.4-.391A.395.395,0,0,1,84.584,291.091Z",
    transform: "translate(-81.738 -283.549)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32732",
    "data-name": "Path 32732",
    d: "M153.7,290.7a.392.392,0,1,1-.4.391A.395.395,0,0,1,153.7,290.7Z",
    transform: "translate(-149.529 -283.549)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateAudit);
export default __webpack_public_path__ + "static/media/Create Audit.feb4d3649bf39b3995bd8eed66aa8930.svg";
export { ForwardRef as ReactComponent };